module.exports = __webpack_public_path__ + "static/media/phone.55a79a72.png";